import { registerLocaleData } from '@angular/common';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, ErrorHandler, LOCALE_ID, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import localeFr from '@angular/common/locales/fr';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, provideNativeDateAdapter } from '@angular/material/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { FR_DATE_FORMATS, FrDateAdapter } from './core/date/fr-date-adapter';
import { CAC_PROVIDER } from './features/gouvernance/portefeuille/fiche-360/onglets/cac-provider.port';
import { AgProviderAdapter } from './features/gouvernance/services/ag-provider.adapter';
import { CacProviderAdapter } from './features/performance/cac/cac-provider.adapter';
import { AG_PROVIDER } from './features/performance/dividendes/ag-provider.port';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { errorInterceptor } from './core/interceptors/error.interceptor';
import { GlobalErrorHandler } from './core/services/global-error-handler';

registerLocaleData(localeFr);

export const appConfig: ApplicationConfig = {
    providers: [
        provideBrowserGlobalErrorListeners(),
        { provide: ErrorHandler, useClass: GlobalErrorHandler },
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(routes),
        provideHttpClient(withInterceptors([authInterceptor, errorInterceptor])),
        provideNativeDateAdapter(),
        { provide: DateAdapter, useClass: FrDateAdapter },
        { provide: MAT_DATE_FORMATS, useValue: FR_DATE_FORMATS },
        { provide: MAT_DATE_LOCALE, useValue: 'fr-FR' },
        { provide: LOCALE_ID, useValue: 'fr-FR' },
        // Port CAC (hexagonal) : découple la Fiche 360° (Gouvernance) des services concrets
        // du module Performance. Binding au composition root car la Fiche 360° s'affiche sur
        // une route Gouvernance où le module Performance n'est pas forcément chargé.
        { provide: CAC_PROVIDER, useClass: CacProviderAdapter },
        // Port AG (hexagonal, audit R-33) : découple Dividendes (Performance) du service
        // d'assemblées générales du module Gouvernance. Même principe de binding au composition root.
        { provide: AG_PROVIDER, useClass: AgProviderAdapter },
        {
            provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
            useValue: {
                appearance: 'fill',
                subscriptSizing: 'dynamic',
            },
        },
    ],
};
